<div class="left_nav-img row">
    <img src="assets/images/side-bar.png" alt="" />
</div>
